import React from "react";
import styled from "styled-components";
import { withTheme } from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactSlider from "react-slider";

const StyledSlider = styled(ReactSlider)`
  width: 100%;
  height: 10px;
  margin: 10px 0;
`;

const StyledThumb = styled.div`
  height: 25px;
  line-height: 25px;
  width: 25px;
  top: -6px;
  text-align: center;
  background-color: ${props => props.theme.color1};
  color: #fff;
  border-radius: 50%;
  cursor: grab;
`;

const Thumb = (props, state) => (
  <StyledThumb {...props}>{state.valueNow}</StyledThumb>
);

const StyledTrack = styled.div`
  top: 0;
  bottom: 0;
  background: ${props =>
    props.index === 2
      ? "#ddd"
      : props.index === 1
      ? props.theme.color3
      : "#ddd"};
  border-radius: 999px;
`;

const Track = (props, state) => <StyledTrack {...props} index={state.index} />;

export default withTheme(({ from, to, onChange }) => {
  return (
    <StyledSlider
      value={[from, to]}
      min={0}
      max={18}
      renderTrack={Track}
      renderThumb={Thumb}
      onChange={v => onChange(v[0], v[1])}
    />
  );
});
